import { TWarboxMessageInitialState } from '../types';

export const updateWarboxMessageState = (
    state: TWarboxMessageInitialState,
    payload: Partial<TWarboxMessageInitialState>
): TWarboxMessageInitialState => ({
    ...state,
    ...payload,
});
